import { TranslationOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import Button, { ButtonProps } from "@/shared/form/button";
import Tooltip from "@/shared/data-display/tooltip";
import { useTranslateLocalizedValue } from "../../model/use-translate-localized-value";

export function AutoTranslateButton(props: ButtonProps) {
  const t = useTranslations("LocalizedValue");

  const { translate, loading, isEmpty } = useTranslateLocalizedValue();

  return (
    <Tooltip title={t("Autotranslate hint")}>
      <Button
        icon={<TranslationOutlined />}
        onClick={translate}
        loading={loading}
        disabled={isEmpty}
        aria-label={t("Autotranslate")}
        data-testid="localized-value-autotranslate-button"
        {...props}
      />
    </Tooltip>
  );
}
